module.exports = __webpack_public_path__ + "static/media/lamps-plus.8d8f6bfc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/header-photos/lamps-plus.jpg
// module id = 839
// module chunks = 27